import type { SVGProps } from '@/types/common.types';

const UzContentSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M15.4517 4.6967C18.3807 7.62563 18.3807 12.3744 15.4517 15.3033C12.5228 18.2322 7.77405 18.2322 4.84514 15.3033C1.9162 12.3744 1.9162 7.62562 4.84514 4.6967C7.77407 1.76777 12.5228 1.76777 15.4517 4.6967"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1484 17.5H17.6484"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.151 14.1666V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.151 5V5.83333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.98177 10H5.14844"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1458 10H14.3125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1016 12.95L13.6849 13.5333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.61719 6.46667L7.20052 7.05001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.20052 12.95L6.61719 13.5333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6849 6.46667L13.1016 7.05001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3296 8.82153C11.9804 9.4724 11.9804 10.5277 11.3296 11.1786C10.6787 11.8294 9.62341 11.8294 8.97253 11.1786C8.32166 10.5277 8.32166 9.4724 8.97253 8.82153C9.62341 8.17066 10.6787 8.17066 11.3296 8.82153"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UzContentSVG;
